import { Component, Input } from '@angular/core';

@Component({
  selector: 'portfolio-branding',
  templateUrl: './portfolio-branding.component.html',
  styleUrls: ['./portfolio-branding.component.scss']
})

export class PortfolioBrandingComponent {
  @Input() brand: string;
  @Input() brandImgAlt: string;
  @Input() brandImgUrl: string;
  @Input() brandLogoAlt: string;
  @Input() brandLogoUrl: string;
  @Input() brandColorsAlt: string;
  @Input() brandColorsUrl: string;
  @Input() color1: string;
  @Input() color2: string;
  @Input() color3: string;
  @Input() color4: string;
  @Input() fontName1: string;
  @Input() fontName2: string;
  @Input() imgContainerAlt: string;
  @Input() imgContainerUrl: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/portfolio-branding/portfolio-branding.component.ts